module.exports = __webpack_public_path__ + "media/images/diy/awards_icon-764e77b9cc347c4b392233ed1aabf110.svg";